<template>
<div>
  <a-cascader :options="data"  expandTrigger="hover"  :showSearch="{filter}"  @change="onChange" :placeholder="placeholder" :popupClassName='popupClassName'  style="width:100%"/>
</div>
</template>
<script>
export default {
     name: 'hp-manager-cascader',
     props:{
         data:Array,
         placeholder:String,
         popupClassName:String,
     },
  data() {
    return {
    }
  },
  methods: {
    onChange(value, selectedOptions) {
      this.$emit('refresh',{value:value,selectedOptions:selectedOptions})
     // console.log(value, selectedOptions);
    },
    filter(inputValue, path) {
      return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/cascader/cascader.vue